import { Injectable } from '@angular/core';

import { SnComponentUpdater } from '@lib/core';

import { SnSmartButtonGroup } from '../models/smart-button-group.model';
import { SnSmartButtonConfig } from '../types/smart-button-config';
import { SnSmartButtonGroupEvent } from '../types/smart-button-group-event';

@Injectable({ providedIn: 'root' })
export class SnSmartButtonGroupService {
  private readonly _groups = new Map<string, SnSmartButtonGroup>();

  constructor(private readonly _componentUpdater: SnComponentUpdater<SnSmartButtonGroupEvent>) {}

  public getGroup(id: string): SnSmartButtonGroup {
    if (!this._groups.has(id)) {
      const group = new SnSmartButtonGroup(id, this._componentUpdater);
      this._groups.set(id, group);
    }

    return this._groups.get(id);
  }

  public hideGroup(groupName: string): void {
    this.getGroup(groupName).hide();
  }

  public showGroup(groupName: string): void {
    this.getGroup(groupName).show();
  }

  public clearGroup(groupName: string): void {
    this.getGroup(groupName).clear();
  }

  public setButtons(groupName: string, ...buttons: SnSmartButtonConfig[]): void {
    const buttonGroup = this.getGroup(groupName);
    buttonGroup.setButtons(...buttons);
  }

  public deleteButton(groupName: string, buttonName: string): boolean {
    return this.getGroup(groupName).deleteButton(buttonName);
  }

  public disableButton(groupName: string, buttonName: string): void {
    this.getGroup(groupName).disableButton(buttonName);
  }

  public enableButton(groupName: string, buttonName: string): void {
    this.getGroup(groupName).enableButton(buttonName);
  }
}
